/* eslint-disable max-len */
import React from 'react';


const StarIcon = ({ extraClassName }) => (
  <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg"
    className={extraClassName}>
    <path
      d="M9.10326 0.816986C9.47008 0.0737407 10.5299 0.0737401 10.8967 0.816986L13.0001 5.07896C13.1458
                  5.37411 13.4274 5.57868 13.7531 5.62601L18.4565 6.30945C19.2767 6.42863 19.6042 7.4366 19.0107
                  8.01514L15.6073 11.3326C15.3716 11.5624 15.264 11.8934 15.3197 12.2178L16.1231 16.9021C16.2632
                  17.719 15.4058 18.342 14.6722 17.9563L10.4653 15.7446C10.174 15.5915 9.82598 15.5915 9.53466
                  15.7446L5.32784 17.9563C4.59421 18.342 3.73677 17.719 3.87688 16.9021L4.68032 12.2178C4.73596
                  11.8934 4.62841 11.5624 4.39272 11.3326L0.989329 8.01514C0.395812 7.4366 0.723321 6.42863 1.54354
                  6.30945L6.24691 5.62601C6.57262 5.57868 6.85419 5.37411 6.99985 5.07896L9.10326 0.816986Z"
      fill="#373434" />
  </svg>
);


export default StarIcon;
